const translations = {
  popover: {
    clearAll: "Clear all",
    markAllAsRead: "Mark all as read"
  }
};

export default translations;
